import React, { useState, useEffect } from 'react';
import { getTemplates, createTemplate, updateTemplate } from '../common/whatsapp';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  DialogContentText,
  Tabs,
  Tab,
  Box,
  Grid,
  IconButton,
  FormControlLabel,
  Checkbox,
  Chip,
} from '@material-ui/core';
import { Add, Edit, Delete, Close, AddCircleOutline } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { API_POST } from '../../services/api.service';
import InfoBox from '../../components/InfoIcon/InfoIcon';


const Alert = ({ message, onClose }) => {
  
}

// WhatsApp template configuration
const TEMPLATE_TYPES = {
  TEXT: 'TEXT',
  MEDIA: 'MEDIA',
  INTERACTIVE: 'INTERACTIVE',
};

const MEDIA_TYPES = [
  { value: 'IMAGE', label: 'Image' },
  { value: 'VIDEO', label: 'Video' },
  { value: 'DOCUMENT', label: 'Document' },
];

const INTERACTIVE_TYPES = [
  { value: 'BUTTON', label: 'Button' },
  { value: 'LIST', label: 'List' },
  { value: 'PRODUCT', label: 'Product' },
  { value: 'PRODUCT_LIST', label: 'Product List' },
];

const BUTTON_TYPES = [
  { value: 'QUICK_REPLY', label: 'Quick Reply' },
  { value: 'URL', label: 'URL' },
  { value: 'PHONE_NUMBER', label: 'Phone Number' },
];

const languageCodes = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { value: 'fr', name: 'French' },
];

const categories = ['UTILITY', 'MARKETING', 'AUTHENTICATION'];

const Template = ({ user, whatsappAccountSelectionOptions, phoneSelections }) => {
  const { admin, username } = user;
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [mapBox, setMapBox] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  // Template form state
  const [templateForm, setTemplateForm] = useState({
    templateName: '',
    category: '',
    language: 'en',
    wabaId: '',
    type: TEMPLATE_TYPES.TEXT,
    header: { type: 'TEXT', text: '' },
    body: { text: '', variables: [] },
    footer: { text: '' },
    buttons: [],
    media: { type: '', url: '' },
    interactive: { type: '', options: {} },
    variables: [],
    example: { body_text: [] },
    status: 'PENDING',
  });

  useEffect(() => {
    if (!admin) return;

    const fetchTemplates = async () => {
      setLoading(true);
      try {
        const response = await getTemplates({ admin, username, allTemplates: true });
        setTemplates(response);
      } catch (err) {
        setError(err.message || 'Failed to fetch templates');
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, [admin, username]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTemplateForm(prev => ({ ...prev, [name]: value }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setTemplateForm(prev => ({
      ...prev,
      [section]: { ...prev[section], [field]: value }
    }));
  };

  const handleAddVariable = () => {
    setTemplateForm(prev => ({
      ...prev,
      body: {
        ...prev.body,
        variables: [...prev.body.variables, { name: '', example: '' }]
      }
    }));
  };

  const handleVariableChange = (index, field, value) => {
    setTemplateForm(prev => {
      const newVariables = [...prev.body.variables];
      newVariables[index][field] = value;
      return {
        ...prev,
        body: { ...prev.body, variables: newVariables }
      };
    });
  };

  const handleRemoveVariable = (index) => {
    setTemplateForm(prev => {
      const newVariables = [...prev.body.variables];
      newVariables.splice(index, 1);
      return {
        ...prev,
        body: { ...prev.body, variables: newVariables }
      };
    });
  };

  const handleAddButton = () => {
    setTemplateForm(prev => ({
      ...prev,
      buttons: [...prev.buttons, { type: 'QUICK_REPLY', text: '', url: '' }]
    }));
  };

  const handleButtonChange = (index, field, value) => {
    setTemplateForm(prev => {
      const newButtons = [...prev.buttons];
      newButtons[index][field] = value;
      return { ...prev, buttons: newButtons };
    });
  };

  const handleRemoveButton = (index) => {
    setTemplateForm(prev => {
      const newButtons = [...prev.buttons];
      newButtons.splice(index, 1);
      return { ...prev, buttons: newButtons };
    });
  };

  const validateForm = () => {
    // Basic validation - expand as needed
    if (!templateForm.templateName) {
      showSnackbar('Template name is required', 'error');
      return false;
    }
    if (!templateForm.category) {
      showSnackbar('Category is required', 'error');
      return false;
    }
    if (!templateForm.wabaId) {
      showSnackbar('Business account is required', 'error');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      if (currentTemplate) {
        // Update existing template
        const updatedTemplate = await updateTemplate({
          id: currentTemplate.id,
          ...templateForm
        });
       // setTemplates(prev => prev.map(t => t.id === updatedTemplate.id ? updatedTemplate : t));
       // showSnackbar('Template updated successfully', 'success');
      } else {
        // Create new template
        templateForm.templateName = templateForm.templateName.toLowerCase();
        const newTemplate = await createTemplate(templateForm);

        //setTemplates(prev => [...prev, newTemplate]);
       
        //showSnackbar('Template created successfully', 'success');
      }
      window.location.reload();
      handleCloseDialog();
    } catch (err) {
      showSnackbar(err.message || 'Operation failed', 'error');
    }
  };

  const handleEdit = async (template) => {
    setCurrentTemplate(template);
    setMapBox(true);

  };


  const handleMap = async () => {

    console.log("curentTemplate...",currentTemplate);

    const template = currentTemplate;
    const phoneNumberId = phoneSelect;

    console.log(variableArray)
    

    let apiUrl = `https://metawhatsapp.betyphon.in/api/sendTemplate?admin=${admin}&phoneNumberId=${phoneNumberId}&templateName=${template.name}&phoneNumber=`+'${phone}';

    const templateDetails = extractTemplateInfo(template);

    let variables = null;
    if(templateDetails.variablePosition === 'BODY' && templateDetails.variables.length > 0) {
      variables = JSON.stringify({ body: variableArray.length ? variableArray :   templateDetails.variableDefaultValue });
      apiUrl += `&variables=${variables}`;
    }

    const configObj = {
      root: "CallingSetup",
      body:{
          "api":apiUrl,
          "name": "META_CONFIGURATION_"+template.name,
          "admin": admin,
          "IsActive":true,
          "type":"WhatsAPI",
          "createdBy": admin,
          "createdOn": new Date()
      },
      querydata: {name: "META_CONFIGURATION_"+template.name}
    }
    console.log("configObj...",configObj);
    const createTemplateinBetyphon = await API_POST('action/addRecord', configObj);

    if(createTemplateinBetyphon.data) {
      
      const templateobj = {
        "root": "Templates",
        "body": {
          "type": "whatsapp",
          "body": null,
          "name": "META_TEMPLATE_"+template.name,
          "setup_id": createTemplateinBetyphon.data,
          "admin": admin,
          "isActive": true,
          "createdBy": admin,
          "createdOn": new Date()
        },
        querydata: {name: "META_TEMPLATE_"+template.name}
      }

      await API_POST('action/upsert', templateobj);

      alert("Template Created Successfully");
      console.log("template creation response", templateobj)
    }
    console.log(createTemplateinBetyphon);

    setMapBox(false);
  }

  const handleDelete = async () => {
    try {
      // await deleteTemplate(deleteConfirm.id);
     // setTemplates(prev => prev.filter(t => t.id !== deleteConfirm.id));
      setDeleteConfirm(null);
      showSnackbar('Template deleted successfully', 'success');
    } catch (err) {
      showSnackbar(err.message || 'Delete failed', 'error');
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setMapBox(false)
    setCurrentTemplate(null);
    setTemplateForm({
      templateName: '',
      category: '',
      language: 'en',
      wabaId: '',
      type: TEMPLATE_TYPES.TEXT,
      header: { type: 'TEXT', text: '' },
      body: { text: '', variables: [] },
      footer: { text: '' },
      buttons: [],
      media: { type: '', url: '' },
      interactive: { type: '', options: {} },
      variables: [],
      example: { body_text: [] },
      status: 'PENDING',
    });
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const renderTemplateForm = () => {
    switch (templateForm.type) {
      case TEMPLATE_TYPES.MEDIA:
        return renderMediaTemplateForm();
      case TEMPLATE_TYPES.INTERACTIVE:
        return renderInteractiveTemplateForm();
      default:
        return renderTextTemplateForm();
    }
  };

  const renderTextTemplateForm = () => (
    <>
      <TextField
        fullWidth
        margin="normal"
        label="Header Text"
        value={templateForm.header.text}
        onChange={(e) => handleNestedInputChange('header', 'text', e.target.value)}
      />
      
      <TextField
        fullWidth
        margin="normal"
        label="Body Text"
        multiline
        rows={4}
        value={templateForm.body.text}
        onChange={(e) => handleNestedInputChange('body', 'text', e.target.value)}
        helperText="Use {{1}} for variables"
      />
      
      <div>
        <Typography variant="subtitle2">Variables:</Typography>
        {templateForm.body.variables.map((variable, index) => (
          <Grid container spacing={2} key={index} alignItems="center">
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Variable Name"
                value={variable.name}
                onChange={(e) => handleVariableChange(index, 'name', e.target.value)}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Example Value"
                value={variable.example}
                onChange={(e) => handleVariableChange(index, 'example', e.target.value)}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => handleRemoveVariable(index)}>
                <Close />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Button 
          startIcon={<AddCircleOutline />} 
          onClick={handleAddVariable}
          color="primary"
        >
          Add Variable
        </Button>
      </div>
      
      <TextField
        fullWidth
        margin="normal"
        label="Footer Text"
        value={templateForm.footer.text}
        onChange={(e) => handleNestedInputChange('footer', 'text', e.target.value)}
      />
    </>
  );

  const renderMediaTemplateForm = () => (
    <>
      <FormControl fullWidth margin="normal">
        <InputLabel>Media Type</InputLabel>
        <Select
          value={templateForm.media.type}
          onChange={(e) => handleNestedInputChange('media', 'type', e.target.value)}
        >
          {MEDIA_TYPES.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <TextField
        fullWidth
        margin="normal"
        label="Media URL"
        value={templateForm.media.url}
        onChange={(e) => handleNestedInputChange('media', 'url', e.target.value)}
        helperText="Provide a publicly accessible URL"
      />
      
      {renderTextTemplateForm()}
    </>
  );

  const renderInteractiveTemplateForm = () => (
    <>
      <FormControl fullWidth margin="normal">
        <InputLabel>Interactive Type</InputLabel>
        <Select
          value={templateForm.interactive.type}
          onChange={(e) => handleNestedInputChange('interactive', 'type', e.target.value)}
        >
          {INTERACTIVE_TYPES.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <Typography variant="subtitle2" style={{ marginTop: 16 }}>Buttons:</Typography>
      {templateForm.buttons.map((button, index) => (
        <div key={index} style={{ marginBottom: 16, border: '1px solid #eee', padding: 16, borderRadius: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Button Type</InputLabel>
                <Select
                  value={button.type}
                  onChange={(e) => handleButtonChange(index, 'type', e.target.value)}
                >
                  {BUTTON_TYPES.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                margin="normal"
                label={button.type === 'URL' ? 'Button Text' : 'Button Text'}
                value={button.text}
                onChange={(e) => handleButtonChange(index, 'text', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <IconButton 
                onClick={() => handleRemoveButton(index)}
                style={{ marginTop: 16 }}
              >
                <Close />
              </IconButton>
            </Grid>
            {button.type === 'URL' && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  margin="normal"
                  label="URL"
                  value={button.url}
                  onChange={(e) => handleButtonChange(index, 'url', e.target.value)}
                />
              </Grid>
            )}
          </Grid>
        </div>
      ))}
      <Button 
        startIcon={<AddCircleOutline />} 
        onClick={handleAddButton}
        color="primary"
      >
        Add Button
      </Button>
      
      {renderTextTemplateForm()}
    </>
  );


  const extractTemplateInfo = (template) => {
    const result = {
        type: '',
        variables: [],
        variableDefaultValue: [],
        variablePosition: ''
    };

    // Determine template type based on components
    const hasButtons = template.components.some(comp => comp.type === 'BUTTONS');
    const hasMedia = template.components.some(comp => comp.format === 'IMAGE' || comp.format === 'VIDEO' || comp.format === 'DOCUMENT');
    
    if (hasButtons) {
        result.type = 'button';
    } else if (hasMedia) {
        result.type = 'media';
    } else {
        result.type = 'text';
    }

    // Find variables in BODY component
    const bodyComponent = template.components.find(comp => comp.type === 'BODY');
    if (bodyComponent) {
        // Extract variables like {{1}}, {{2}} etc.
        const variableRegex = /\{\{\d+\}\}/g;
        const matches = bodyComponent.text.match(variableRegex);
        
        if (matches) {
            result.variables = matches;
            result.variablePosition = 'BODY';
            
            // Get default values from example if available
            if (bodyComponent.example && bodyComponent.example.body_text && bodyComponent.example.body_text[0]) {
                result.variableDefaultValue = bodyComponent.example.body_text[0];
            } else {
                // If no example, create default values like "help", "2ndval" etc.
                result.variableDefaultValue = matches.map((_, index) => 
                    index === 0 ? 'help' : `${index + 1}${index === 1 ? 'nd' : index === 2 ? 'rd' : 'th'}val`
                );
            }
        }
    }

    return result;
  }

  const availableFields = ["${firstname}","${phone}","${email}","${address}","${city}","${state}","${country}"];

  const [variableMappings, setVariableMappings] = useState({});
  const [variableArray, setVariableArray] = useState([]);
  const [phoneSelect, setPhoneSelect] = useState(null);

  const handleVariableMappingChange = (varName, field) => {
    setVariableMappings(prev => ({
      ...prev,
      [varName]: field
    }));


    let tmpArray = variableArray;
    tmpArray.push(field);
    setVariableArray(tmpArray);

    console.log(variableArray)
  };
    
  return (
    <div>
      <br/>
       <span style={{float:"right"}}>
            <InfoBox name={'Whatsapp.template'} />
        </span>
      <Typography variant="h4" gutterBottom>
        WhatsApp Templates
      </Typography>
      
      <Button
        variant="contained"
        color="primary"
        startIcon={<Add />}
        onClick={() => setOpenDialog(true)}
        style={{ marginBottom: 20 }}
      >
        Create New Template
      </Button>

      <span style={{float:"right"}}>
        <a href="https://business.facebook.com/wa/manage/message-templates" >Manage Templates</a>
      </span>

      {error && (
        <Alert severity="error" style={{ marginBottom: 20 }}>
          {error}
        </Alert>
      )}

      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Language</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {templates && templates.length && templates.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((template) => (
                  <TableRow key={template.id}>
                    <TableCell>{template.name}</TableCell>
                    <TableCell>
                      <Chip label={extractTemplateInfo(template).type} size="small" />
                      {
                        extractTemplateInfo(template).variables.length > 0 && (
                          <Chip label={extractTemplateInfo(template).variables.join(', ')} size="small" />
                        )
                      }
                      
                    </TableCell>
                    <TableCell>{template.category}</TableCell>
                    <TableCell>
                    {template.language}
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={template.status} 
                        size="small" 
                        color={
                          template.status === 'APPROVED' ? 'primary' : 
                          template.status === 'REJECTED' ? 'secondary' : 'default'
                        } 
                      />
                    </TableCell>
                    <TableCell>
                    <Button
        variant="contained"
        color="primary"
        startIcon={<Add />}
        onClick={() => handleEdit(template)}
        style={{ marginBottom: 20 }}
      >
        use template
      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={templates && templates.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
          />
        </>
      )}

      {
         currentTemplate && (
<Dialog open={mapBox} onClose={handleCloseDialog} fullWidth maxWidth="md">
  <DialogTitle>
    {currentTemplate ? 'Edit Template' : 'Create New Template'}
    <IconButton
      aria-label="close"
      onClick={handleCloseDialog}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <Close />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers>
    <Box p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth margin="normal">
            <InputLabel id="phone-number-label">Phone Number</InputLabel>
            <Select
              labelId="phone-number-label"
              label="Phone Number"
              name="phoneNumber"
              value={phoneSelect}
              onChange={(e)=>setPhoneSelect(e.target.value)}
              required
            >

              {phoneSelections &&
                                phoneSelections.map((user) => (
                                  <MenuItem key={user.key} value={user.key}>
                                    {user.value}
                                  </MenuItem>
                                ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Variables Mapping
          </Typography>
          
          {extractTemplateInfo(currentTemplate).variables.map((varName, index) => (
            <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
              <Grid item xs={5}>
                <TextField
                  fullWidth
                  label="Variable Name"
                  value={varName}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={7}>
                <FormControl fullWidth>
                  <InputLabel>Map to Field</InputLabel>
                  <Select
                    value={variableMappings[varName] || ''}
                    onChange={(e) => handleVariableMappingChange(varName, e.target.value)}
                    label="Map to Field"
                  >
                    <MenuItem value="">None</MenuItem>
                    {availableFields.map((field) => (
                      <MenuItem key={field} value={field}>{field}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseDialog}>Cancel</Button>
    <Button onClick={handleMap} variant="contained" color="primary">
      {currentTemplate ? 'Update' : 'Create'}
    </Button>
  </DialogActions>
</Dialog>
         )


      }




      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
        <DialogTitle>
          {currentTemplate ? 'Edit Template' : 'Create New Template'}
        </DialogTitle>
        <DialogContent>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Basic Info" />
            <Tab label="Template Content" />
            <Tab label="Variables & Examples" />
          </Tabs>
          
          <Box p={3}>
            {activeTab === 0 && (
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Template Name"
                    name="templateName"
                    value={templateForm.templateName}
                    onChange={handleInputChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Category *</InputLabel>
                    <Select
                      name="category"
                      value={templateForm.category}
                      onChange={handleInputChange}
                      required
                    >
                      {categories.map((category) => (
                        <MenuItem key={category} value={category}>
                          {category}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Business Account *</InputLabel>
                    <Select
                      name="wabaId"
                      value={templateForm.wabaId}
                      onChange={handleInputChange}
                      required
                    >
                      {whatsappAccountSelectionOptions.map((account) => (
                        <MenuItem key={account.id} value={account.id}>
                          {account.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Language *</InputLabel>
                    <Select
                      name="language"
                      value={templateForm.language}
                      onChange={handleInputChange}
                      required
                    >
                      {languageCodes.map((lang) => (
                        <MenuItem key={lang.code} value={lang.code}>
                          {lang.name} ({lang.code})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Template Type</InputLabel>
                    <Select
                      name="type"
                      value={templateForm.type}
                      onChange={handleInputChange}
                    >
                      {Object.values(TEMPLATE_TYPES).map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            )}
            
            {activeTab === 1 && renderTemplateForm()}
            
            {activeTab === 2 && (
              <div>
                <Typography variant="subtitle2" gutterBottom>
                  Example Data for Approval
                </Typography>
                {templateForm.body.variables.map((variable, index) => (
                  <TextField
                    key={index}
                    fullWidth
                    margin="normal"
                    label={`Example for ${variable.name || `Variable ${index + 1}`}`}
                    value={variable.example}
                    onChange={(e) => handleVariableChange(index, 'example', e.target.value)}
                  />
                ))}
              </div>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            {currentTemplate ? 'Update Template' : 'Create Template'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={!!deleteConfirm} onClose={() => setDeleteConfirm(null)}>
        <DialogTitle>Delete Template</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete  template? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirm(null)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="secondary" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

Template.propTypes = {
  user: PropTypes.shape({
    admin: PropTypes.bool.isRequired,
    username: PropTypes.string.isRequired,
  }).isRequired,
  whatsappAccountSelectionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Template;